import {createActions} from 'client/framework';

const normalActions = [
  'CLEAR_SEARCH_TERM',
  'SET_SEARCH_TERM',
  'SET_VISIBLE_COLUMNS',
  'TOGGLE_COLUMN',
  'TOGGLE_SEARCH_VISIBILITY'
];

export default createActions(null, normalActions);
